/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import EditIcon from '@atlaskit/icon/glyph/edit';
var editIconStyles = css({
  width: '20px'
});

/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */
export var SmallerEditIcon = function SmallerEditIcon() {
  return jsx("div", {
    css: editIconStyles
  }, jsx(EditIcon, {
    label: "edit"
  }));
};
/* eslint-enable @atlaskit/design-system/consistent-css-prop-usage */